

































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { PTOPolicy } from "@/dto/payroll/policies/PTOPolicyDTO";
import { prettyEnum } from "@/utils/StringUtils";
import moment, { Moment } from "moment-timezone";
import EmbeddedFile from "@/components/common/EmbeddedFile.vue";
import BTPortalCollapse from "@/components/common/BTPortalCollapse.vue";

@Component({
	components: { EmbeddedFile, BTPortalCollapse }
})
export default class PTOPolicyCard extends Vue {
	@Prop({ required: true })
	private policy!: PTOPolicy;

	private get officerName(): string {
		return (this.policy.officer && this.policy.officer.name) || '';
	}

	private prettyEnum = prettyEnum;
	private moment(inp?: moment.MomentInput, format?: moment.MomentFormatSpecification): Moment {
		return moment(inp, format);
	}
}
